import { trpc as approvalTrpc } from '@tencent/tpro_rmonitor_product_manager_approval';
import { trpc } from '@tencent/tpro_rmonitor_product_manager_role';
import { Input, message, Modal, Radio, RadioChangeEvent, Select } from 'antd';
import { get } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EXPIRE_OPTIONS, getExpireTime } from '@/presentation/components/internal-approval';
import { stores } from '@/presentation/store';
import { approvalService } from '@/service/approval';
import { roleService } from '@/service/role';
import { WithTypeCast } from '@raft/utils';
import style from './../index.module.scss';
import Expire = approvalTrpc.rmonitor.product_manager.Expire;
type IRoleInfo = WithTypeCast<trpc.rmonitor.product_manager.IRoleInfo>;

const { TextArea } = Input;

interface PropsType {
  permissionDialogVisible: boolean;
  setPermissionDialogVisible: (value: boolean) => void;
  setSubmitDialogVisible: (value: boolean) => void;
  setIsSubmitResult: (value: string) => void;
}

export const SendPermission = (props: PropsType) => {
  const { t } = useTranslation();
  const {
    permissionDialogVisible,
    setPermissionDialogVisible,
    setSubmitDialogVisible,
    setIsSubmitResult,
  } = props;
  const { productId } = stores.ProductStore;
  const [applyReason, setApplyReason] = useState('');
  const [applyType, setApplyType] = useState<number>();
  const [expireDate, setExpireDate] = useState<Expire>(Expire.THREE_MONTHS);
  const [roleArr, setRoleArr] = useState<IRoleInfo[]>([]);

  const load = async () => {
    const data = await roleService.getRoles({
      productId,
    });

    const defaultRoleType: number = get(data, '[1].id', 0);
    setApplyType(defaultRoleType);
    setRoleArr(data);
  };

  useEffect(() => {
    load();
  }, []);

  const handleOk = async () => {
    if (!applyReason) {
      message.warning(t('未填写申请理由！'));
      return;
    }
    // 发送申请
    const res = await approvalService.applyProductRole({
      productId,
      roleId: applyType,
      expireTime: getExpireTime(expireDate),
      expireType: expireDate,
      reason: applyReason,
    });
    if (res) {
      setIsSubmitResult('succ');
    } else {
      setIsSubmitResult('fail');
    }
    setPermissionDialogVisible(false);
    setSubmitDialogVisible(true);
  };

  return <Modal
    title={t('申请权限')}
    visible={permissionDialogVisible}
    okText={t('发送申请')}
    onOk={handleOk}
    onCancel={() => setPermissionDialogVisible(false)}
  >
    <div className={style.dialogBox}>
      <TextArea
        placeholder={t('请输入申请理由（必填）')}
        autoSize={{ minRows: 6, maxRows: 6 }}
        value={applyReason}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setApplyReason(e.target.value)}
      />
    </div>
    <div className={style.dialogBox}>
      <span style={{ paddingRight: '8px' }}>{t('申请角色:')} </span>
      <Radio.Group
        onChange={(e: RadioChangeEvent) => setApplyType(e.target.value)}
        value={applyType}
      >
        {roleArr.map(role => (
          <Radio value={role.id}>{role.name}</Radio>
        ))}
      </Radio.Group>
    </div>
    <div className={style.dialogBox}>
      <span style={{ paddingRight: '8px' }}>{t('有效期:')} </span>
      <Select
        options={EXPIRE_OPTIONS}
        value={expireDate}
        style={{ width: 180 }}
        onChange={val => setExpireDate(val)}
      />
    </div>
  </Modal>;
};
